import {NullableDate} from "../../../../common/types/nullable-types";
import {IAmountAnimationOptions} from "../../../../utils/amount-animator/amount-animator.interface";

export enum RecurringJackpotStates
{
    None = 0,
    SuperCold = 1,
    Cold = 2,
    Hot = 3,
    Peak = 4, // Within 55 minutes before the drop the jackpot will have this state
    MustHit = 5 // Couple seconds before the drop has this state (basically when it has this state the next spin will win the jackpot)
}

export function isHotRecurringJackpotState(state: RecurringJackpotStates | null | undefined): boolean {
    switch (state) {
        case RecurringJackpotStates.Hot:
        case RecurringJackpotStates.Peak:
        case RecurringJackpotStates.MustHit:
            return true;
        default:
            return false;
    }
}

export interface IJackpotWidgetAmountAnimationOptions extends Pick<IAmountAnimationOptions, 'animationDuration' | 'iterationDuration'>{
    fromAmount?: number;
}

export interface IJackpotViewModel {
    readonly id: number;
    readonly previousAmountInCents: number;
    readonly currentAmountInCents: number;
    readonly widgetCurrentAnimatedAmountInCents: number;
    readonly state: RecurringJackpotStates;
    readonly lastWinAmountInCents: number;
    readonly mustHitTime: NullableDate;
    startWidgetAmountAnimation(options?: IJackpotWidgetAmountAnimationOptions): Promise<void>;
}

export type NullableJackpotViewModel = IJackpotViewModel | null;